<template>
  <div>
    <Menu />

    <section class="uk-section-default uk-section uk-padding-remove-vertical">
      <div class="uk-grid-margin uk-grid uk-grid-stack" uk-grid>
        <div class="uk-width-1-1@m uk-first-column">
          <div
            uk-slideshow="ratio: false; animation: pull; velocity: 0.6; autoplay: 1;"
            class="uk-margin uk-text-left uk-slideshow"
          >
            <div class="uk-position-relative">
              <ul
                class="uk-slideshow-items"
                uk-height-viewport="offset-top: true; minHeight: 300;"
              >
                <li tabindex="-1">
                  <div
                    class="uk-position-cover"
                    uk-slideshow-parallax="scale: 1,1.2,1.2"
                  >
                    <img
                      class="uk-cover"
                      uk-img="target: !.uk-slideshow-items"
                      uk-cover
                      src="https://images.pexels.com/photos/1304469/pexels-photo-1304469.jpeg"
                    />
                  </div>
                  <div
                    class="uk-position-cover"
                    uk-slideshow-parallax="opacity: 0.5,0,0; backgroundColor: #000,#000"
                  ></div>
                  <div
                    class="uk-position-cover uk-flex uk-flex-left uk-flex-middle uk-container uk-section"
                  >
                    <div
                      class="uk-panel uk-width-xlarge uk-light uk-margin-remove-first-child"
                      uk-slideshow-parallax="x: 600,0,-600;"
                    >
                      <h3
                        class="uk-heading-small uk-margin-top uk-margin-remove-bottom"
                      >
                        Fokus på detalj
                      </h3>
                    </div>
                  </div>
                </li>
                <li tabindex="-1">
                  <div
                    class="uk-position-cover"
                    uk-slideshow-parallax="scale: 1,1.2,1.2"
                  >
                    <img
                      class="uk-cover"
                      uk-img="target: !.uk-slideshow-items"
                      uk-cover
                      src="https://images.pexels.com/photos/428105/pexels-photo-428105.jpeg"
                    />
                  </div>
                  <div
                    class="uk-position-cover"
                    uk-slideshow-parallax="opacity: 0.5,0,0; backgroundColor: #000,#000"
                  ></div>
                  <div
                    class="uk-position-cover uk-flex uk-flex-left uk-flex-middle uk-container uk-section"
                  >
                    <div
                      class="uk-panel uk-width-xlarge uk-light uk-margin-remove-first-child"
                      uk-slideshow-parallax="x: 600,0,-600;"
                    >
                      <h3
                        class="uk-heading-small uk-margin-top uk-margin-remove-bottom"
                      >
                        Perfektion är vår styrka
                      </h3>
                    </div>
                  </div>
                </li>
              </ul>
              <div
                class="uk-position-bottom-center uk-position-medium uk-light uk-visible@m"
              >
                <ul class="uk-thumbnav uk-flex-center" uk-margin>
                  <li uk-slideshow-item="0" class="uk-first-column">
                    <a href="#">
                      <img
                        alt
                        src="https://images.pexels.com/photos/1304469/pexels-photo-1304469.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"
                      />
                    </a>
                  </li>
                  <li uk-slideshow-item="1">
                    <a href="#">
                      <img
                        alt
                        src="https://images.pexels.com/photos/428105/pexels-photo-428105.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="uk-section-default uk-section uk-section-large">
      <div class="uk-container">
        <div class="uk-grid-margin uk-grid uk-grid-stack" uk-grid>
          <div class="uk-width-1-1@m uk-first-column">
            <h2 class="uk-width-xxlarge uk-margin-auto uk-text-center">
              Vi har alltid kund i fokus
            </h2>
            <div class="uk-margin-medium uk-text-center">
              <a
                class="uk-button uk-button-text"
                title="Learn more about us"
                href="#"
                >Se alla våra bilder</a
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      class="uk-section-default uk-section uk-section-large uk-padding-remove-top"
    >
      <div class="uk-container">
        <div class="uk-grid-margin uk-grid uk-grid-stack" uk-grid>
          <div class="uk-width-1-1@m uk-first-column">
            <h3 class="uk-h5 uk-heading-line uk-margin-medium uk-text-center">
              <span>Senaste bilderna</span>
            </h3>
            <Latest />
          </div>
        </div>
      </div>
    </section>

    <section class="uk-section-secondary">
      <div
        data-src="https://images.pexels.com/photos/3298635/pexels-photo-3298635.jpeg"
        data-sizes="(max-aspect-ratio: 2560/943) 271vh"
        uk-img
        class="uk-background-norepeat uk-background-cover uk-background-center-center uk-section uk-section-large"
      >
        <div class="uk-container">
          <div class="uk-grid-margin uk-grid uk-grid-stack" uk-grid>
            <div class="uk-width-1-1@m uk-first-column">
              <h3
                class="uk-h2 uk-margin-medium uk-width-large uk-margin-auto uk-text-center"
              >
                Vill du boka tid?
              </h3>
              <div class="uk-margin uk-text-center">
                <a class="uk-button uk-button-text" title="Learn more" href="#"
                  >Gå till vår Facebook sida</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
import Menu from "./Menu";
import Footer from "./Footer";
import Latest from "./Latest";

export default {
  name: "Main",
  components: {
    Menu,
    Footer,
    Latest
  },
  mounted() {
    //
  }
};
</script>
